/* MCJ: (1) sparkle-to-cart + bump on the main product-page Add to Cart button
   (mirrors the product-card icon animation); (2) open the cart drawer INSTANTLY on
   click so it feels immediate instead of waiting ~1s for the theme's server-rendered
   drawer. The theme still performs the real add and fills the drawer when ready — we
   never touch the add request itself, so adding to cart can't break. Reuses the
   .mc-spark / .mc-bump styles from mc-cart.css. */
(function () {
  'use strict';
  var ADD_SEL = '.product-form__submit, button[name="add"], .add-cart-button';
  var SKIP_SEL = 'quick-buy.bls__product-addtocart-js'; /* card buttons: handled by mc-cart.js */
  var lastFire = 0;

  function cartTarget() {
    var list = [];
    ['#cart-icon-bubble', '.bls-minicart-action', '[data-bag-cart]', '.cart-count'].forEach(function (s) {
      document.querySelectorAll(s).forEach(function (e) { list.push(e); });
    });
    var vw = window.innerWidth, vh = window.innerHeight, best = null, bestTop = Infinity;
    list.forEach(function (e) {
      if (e.offsetParent === null) return;
      var r = e.getBoundingClientRect();
      if (r.width < 5 || r.height < 5 || r.height > 120) return;
      var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      if (cx < 2 || cx > vw - 2 || cy < 0 || cy > vh) return;
      if (r.top < bestTop) { bestTop = r.top; best = e; }
    });
    return best;
  }

  function flyToCart(btn) {
    if (!btn || typeof requestAnimationFrame === 'undefined') return;
    var b = btn.getBoundingClientRect();
    if (!b.width) return;
    var target = cartTarget(), ex, ey, bumpEl = null;
    if (target) { var t = target.getBoundingClientRect(); ex = t.left + t.width / 2; ey = t.top + t.height / 2; bumpEl = target.closest('a') || target; }
    else { ex = window.innerWidth - 30; ey = 28; }
    var sx = b.left + b.width / 2, sy = b.top + b.height / 2;
    var cx = (sx + ex) / 2, cy = Math.min(sy, ey) - 130;
    var s = document.createElement('div');
    s.className = 'mc-spark';
    s.innerHTML = '<svg viewBox="0 0 24 24"><path d="M12 1.6l2.6 6.9 7 .4-5.4 4.4 1.8 6.8L12 16.7 5.4 20.5l1.8-6.8L1.8 8.9l7-.4z"/></svg>';
    document.body.appendChild(s);
    var killer = setTimeout(function () { if (s && s.parentNode) s.remove(); }, 1600);
    var dur = 760, t0 = null;
    function ease(p) { return 1 - Math.pow(1 - p, 3); }
    function frame(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1), e = ease(p);
      var x = (1 - e) * (1 - e) * sx + 2 * (1 - e) * e * cx + e * e * ex;
      var y = (1 - e) * (1 - e) * sy + 2 * (1 - e) * e * cy + e * e * ey;
      var sc = 1 - 0.55 * p, rot = p * 620;
      s.style.transform = 'translate(' + x + 'px,' + y + 'px) translate(-50%,-50%) scale(' + sc.toFixed(3) + ') rotate(' + rot.toFixed(1) + 'deg)';
      s.style.opacity = p < 0.8 ? '1' : ((1 - p) / 0.2).toFixed(2);
      if (p < 1) { requestAnimationFrame(frame); }
      else {
        clearTimeout(killer);
        s.remove();
        if (bumpEl) { bumpEl.classList.remove('mc-bump'); void bumpEl.offsetWidth; bumpEl.classList.add('mc-bump'); setTimeout(function () { bumpEl.classList.remove('mc-bump'); }, 460); }
      }
    }
    requestAnimationFrame(frame);
  }

  /* Open the theme's cart drawer immediately (no waiting for the server render). The
     theme will re-open + populate it a moment later; open()/close() are idempotent. */
  function openDrawerInstant() {
    var cn = document.querySelector('cart-notification');
    if (cn && typeof cn.open === 'function') { try { cn.open(); } catch (e) {} }
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest(ADD_SEL);
    if (!btn) return;
    if (btn.closest(SKIP_SEL)) return;
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    var now = Date.now();
    if (now - lastFire < 350) return;
    lastFire = now;
    flyToCart(btn);
    openDrawerInstant();
  }, false);
})();
